var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageWrapper',[_c('div',{staticClass:"error404"},[_vm._v(" This page is not available ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }